/**
 * @author       [Tim Vermaelen]
 * @date         [2023]
 * @link         [http://www.adequatelygood.com/JavaScript-Module-Pattern-In-Depth.html]
 * @namespace    [Blastic.Navigation]
 * @requires     [jQuery, Blastic]
 * @revision     [0.2]
 */

// @param ($): window.jQuery
// @param (ns): window.Blastic
window.Blastic = (function ($, ns) {

    // 1. ECMA-262/5
    'use strict';

    // 2. CONFIGURATION
    const cfg = {
        cache: {
            navbar: '#navbar',
            navbarDark: '#navbar-dark',
            menu: '#menuToggle input'
        },
        classes: {
            scrolled: 'navbar-scrolled',
            scrolledDark: 'navbar-scrolled-dark',
            noScrollY: 'no-scroll-y',
            navbarAddition: 'navbar-blog'
        },
        events: {
            change: 'change',
            scroll: 'scroll'
        },
        options: {
            scrolling: {
                passive: true
            }
        }
    };

    // 3. FUNCTIONS OBJECT
    ns.Navigation = {

        revision: 0.2,

        init: function () {
            this.cacheItems();

            if (this.container) {
                this.activate();
            }
        },

        cacheItems: function () {
            const { cache } = Object.assign(cfg);

            this.navbar = document.querySelector(cache.navbar);
            this.navbarDark = document.querySelector(cache.navbarDark);
            this.container = this.navbar || this.navbarDark;
            this.isDarkMode = this.container && this.container === this.navbarDark;
            this.menu = document.querySelector(cache.menu);
        },

        activate: function () {
            this.verifyCorrections();
            this.bindEvents();
        },

        bindEvents: function () {
            const { events, options } = Object.assign(cfg);

            window.addEventListener(events.scroll, this.handleScroll.bind(this), options.scrolling);
            this.menu && this.menu.addEventListener(events.change, this.handleMenuToggle.bind(this));
        },

        handleScroll: function () {
            const { classes } = Object.assign(cfg);
            const isScrolled = window.scrollY >= 10;

            this.container.classList.toggle(classes.scrolled, isScrolled);
            this.isDarkMode && this.container.classList.toggle(classes.scrolledDark, isScrolled);
        },

        handleMenuToggle: function () {
            const { classes } = Object.assign(cfg);
            const hasNoScrollY = document.body.classList.contains(classes.noScrollY);

            document.body.classList.toggle(classes.noScrollY, !hasNoScrollY);
        },

        verifyCorrections: function () {
            const { classes } = Object.assign(cfg);
            const isBlog = window.location.href.startsWith('blog');
            const isWork = window.location.href.startsWith('our-work');
            const isContact = window.location.href.indexOf('contact') > -1;

            if (isBlog || isWork || isContact) {
                this.navbarDark.classList.add(classes.navbarAddition);
            }
        }

    }

    // 4. NAMESPACE
    return ns;

})(window.jQuery, window.Blastic || {});

